/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DashboardRouteRouteImport } from './routes/dashboard/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as DashboardQuestionsIndexRouteImport } from './routes/dashboard/questions/index'
import { Route as DashboardPickemsIndexRouteImport } from './routes/dashboard/pickems/index'
import { Route as DashboardLeaguesIndexRouteImport } from './routes/dashboard/leagues/index'
import { Route as DashboardDevToolsIndexRouteImport } from './routes/dashboard/dev-tools/index'
import { Route as DashboardQuestionsIdRouteImport } from './routes/dashboard/questions/$id'
import { Route as DashboardPickemsIdRouteImport } from './routes/dashboard/pickems/$id'
import { Route as DashboardLeaguesIdRouteImport } from './routes/dashboard/leagues/$id'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRouteRoute = DashboardRouteRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardQuestionsIndexRoute = DashboardQuestionsIndexRouteImport.update({
  id: '/questions/',
  path: '/questions/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardPickemsIndexRoute = DashboardPickemsIndexRouteImport.update({
  id: '/pickems/',
  path: '/pickems/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardLeaguesIndexRoute = DashboardLeaguesIndexRouteImport.update({
  id: '/leagues/',
  path: '/leagues/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardDevToolsIndexRoute = DashboardDevToolsIndexRouteImport.update({
  id: '/dev-tools/',
  path: '/dev-tools/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardQuestionsIdRoute = DashboardQuestionsIdRouteImport.update({
  id: '/questions/$id',
  path: '/questions/$id',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardPickemsIdRoute = DashboardPickemsIdRouteImport.update({
  id: '/pickems/$id',
  path: '/pickems/$id',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardLeaguesIdRoute = DashboardLeaguesIdRouteImport.update({
  id: '/leagues/$id',
  path: '/leagues/$id',
  getParentRoute: () => DashboardRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/leagues/$id': typeof DashboardLeaguesIdRoute
  '/dashboard/pickems/$id': typeof DashboardPickemsIdRoute
  '/dashboard/questions/$id': typeof DashboardQuestionsIdRoute
  '/dashboard/dev-tools': typeof DashboardDevToolsIndexRoute
  '/dashboard/leagues': typeof DashboardLeaguesIndexRoute
  '/dashboard/pickems': typeof DashboardPickemsIndexRoute
  '/dashboard/questions': typeof DashboardQuestionsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/dashboard': typeof DashboardIndexRoute
  '/dashboard/leagues/$id': typeof DashboardLeaguesIdRoute
  '/dashboard/pickems/$id': typeof DashboardPickemsIdRoute
  '/dashboard/questions/$id': typeof DashboardQuestionsIdRoute
  '/dashboard/dev-tools': typeof DashboardDevToolsIndexRoute
  '/dashboard/leagues': typeof DashboardLeaguesIndexRoute
  '/dashboard/pickems': typeof DashboardPickemsIndexRoute
  '/dashboard/questions': typeof DashboardQuestionsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/leagues/$id': typeof DashboardLeaguesIdRoute
  '/dashboard/pickems/$id': typeof DashboardPickemsIdRoute
  '/dashboard/questions/$id': typeof DashboardQuestionsIdRoute
  '/dashboard/dev-tools/': typeof DashboardDevToolsIndexRoute
  '/dashboard/leagues/': typeof DashboardLeaguesIndexRoute
  '/dashboard/pickems/': typeof DashboardPickemsIndexRoute
  '/dashboard/questions/': typeof DashboardQuestionsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/login'
    | '/dashboard/'
    | '/dashboard/leagues/$id'
    | '/dashboard/pickems/$id'
    | '/dashboard/questions/$id'
    | '/dashboard/dev-tools'
    | '/dashboard/leagues'
    | '/dashboard/pickems'
    | '/dashboard/questions'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/dashboard'
    | '/dashboard/leagues/$id'
    | '/dashboard/pickems/$id'
    | '/dashboard/questions/$id'
    | '/dashboard/dev-tools'
    | '/dashboard/leagues'
    | '/dashboard/pickems'
    | '/dashboard/questions'
  id:
    | '__root__'
    | '/'
    | '/dashboard'
    | '/login'
    | '/dashboard/'
    | '/dashboard/leagues/$id'
    | '/dashboard/pickems/$id'
    | '/dashboard/questions/$id'
    | '/dashboard/dev-tools/'
    | '/dashboard/leagues/'
    | '/dashboard/pickems/'
    | '/dashboard/questions/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRouteRoute: typeof DashboardRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/questions/': {
      id: '/dashboard/questions/'
      path: '/questions'
      fullPath: '/dashboard/questions'
      preLoaderRoute: typeof DashboardQuestionsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/pickems/': {
      id: '/dashboard/pickems/'
      path: '/pickems'
      fullPath: '/dashboard/pickems'
      preLoaderRoute: typeof DashboardPickemsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/leagues/': {
      id: '/dashboard/leagues/'
      path: '/leagues'
      fullPath: '/dashboard/leagues'
      preLoaderRoute: typeof DashboardLeaguesIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/dev-tools/': {
      id: '/dashboard/dev-tools/'
      path: '/dev-tools'
      fullPath: '/dashboard/dev-tools'
      preLoaderRoute: typeof DashboardDevToolsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/questions/$id': {
      id: '/dashboard/questions/$id'
      path: '/questions/$id'
      fullPath: '/dashboard/questions/$id'
      preLoaderRoute: typeof DashboardQuestionsIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/pickems/$id': {
      id: '/dashboard/pickems/$id'
      path: '/pickems/$id'
      fullPath: '/dashboard/pickems/$id'
      preLoaderRoute: typeof DashboardPickemsIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/leagues/$id': {
      id: '/dashboard/leagues/$id'
      path: '/leagues/$id'
      fullPath: '/dashboard/leagues/$id'
      preLoaderRoute: typeof DashboardLeaguesIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
  }
}

interface DashboardRouteRouteChildren {
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardLeaguesIdRoute: typeof DashboardLeaguesIdRoute
  DashboardPickemsIdRoute: typeof DashboardPickemsIdRoute
  DashboardQuestionsIdRoute: typeof DashboardQuestionsIdRoute
  DashboardDevToolsIndexRoute: typeof DashboardDevToolsIndexRoute
  DashboardLeaguesIndexRoute: typeof DashboardLeaguesIndexRoute
  DashboardPickemsIndexRoute: typeof DashboardPickemsIndexRoute
  DashboardQuestionsIndexRoute: typeof DashboardQuestionsIndexRoute
}

const DashboardRouteRouteChildren: DashboardRouteRouteChildren = {
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardLeaguesIdRoute: DashboardLeaguesIdRoute,
  DashboardPickemsIdRoute: DashboardPickemsIdRoute,
  DashboardQuestionsIdRoute: DashboardQuestionsIdRoute,
  DashboardDevToolsIndexRoute: DashboardDevToolsIndexRoute,
  DashboardLeaguesIndexRoute: DashboardLeaguesIndexRoute,
  DashboardPickemsIndexRoute: DashboardPickemsIndexRoute,
  DashboardQuestionsIndexRoute: DashboardQuestionsIndexRoute,
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(
  DashboardRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRouteRoute: DashboardRouteRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
